import { getColors, getIconDimensionFit } from '../../utils/matching-profile'

const ICON_SIZE = 26
const ICON_HALF = ICON_SIZE / 2

const UserDimensionValueWithIcon = ({ bottom, left, fit, score }) => {
  const { medium } = getColors({ fit, score })
  const Icon = getIconDimensionFit({ fit, score })

  return (
    <div
      style={{
        position: 'absolute',
        left,
        bottom,
        transform: `translate(-${ICON_HALF}px, ${ICON_HALF}px)`,

        width: ICON_SIZE,
        height: ICON_SIZE,
        backgroundColor: 'white',
        borderRadius: 99999
      }}
      className='flex items-center justify-center'
    >
      <Icon color={medium} />
    </div>
  )
}

export default UserDimensionValueWithIcon
